import * as actionTypes from './actionTypes';

interface I_DepthinfoReq {
    DepartureID?: string;
    ArriveID?: string;
    GoDateStart?: string;
    GoDateEnd?: string;
    GroupID?: string;
    Keywords?: string;
    IsEnsureGroup: string | boolean | null;
    IsSold?: string | boolean | null;
    TravelType?: string | number;
    ThemeID?: string | null;
    TravelPavilionGroupID?: string | null;
}

interface I_GroupListInfoReq {
    ArriveID?: string | null;
    GoDateStart?: string;
    GroupID?: string | null;
    Keywords: string | null;
    IsEnsureGroup?: string | boolean | null;
    IsSold?: string | boolean | null;
    ThemeID?: string | null;
    TravelPavilionGroupID?: string | null;
    GoDateEnd?: string;
    DepartureID?: string | null;
    WeekDay: string;
    PriceList?: any;
    AirlineIDs: string;
    TripTypes: string;
    Tags: string;
    SortType: number | null;
    Days: string;
    TravelType: number;
    IsmoreSchedule?: boolean;
}

interface I_SingleGroupListInfoReq {
    ArriveID?: string | null;
    GoDateStart?: string;
    GroupID?: string | null;
    Keywords: string | null;
    IsEnsureGroup?: string | boolean | null;
    IsSold?: string | boolean | null;
    ThemeID?: string | null;
    TravelPavilionGroupID?: string | null;
    GoDateEnd?: string;
    DepartureID?: string | null;
    WeekDay: string;
    PriceList?: any;
    AirlineIDs: string;
    TripTypes: string;
    Tags: string;
    SortType: number | null;
    Days: string;
    TravelType: number;
    IsmoreSchedule?: boolean;
}

interface I_CallJsonReq {
    TelType: number;
}

export const setDepthinfo = (payload: I_DepthinfoReq) => ({
    type: actionTypes.SET_DEPTHINFO,
    payload,
});

export const setDepthinfoSUCCESS = (payload: any) => ({
    type: actionTypes.SET_DEPTHINFO_SUCCESS,
    payload,
});

export const setGroupListInfo = (payload: I_GroupListInfoReq) => ({
    type: actionTypes.SET_GROUPLISTINFO,
    payload,
});

export const setGroupListInfoSUCCESS = (payload: any) => ({
    type: actionTypes.SET_GROUPLISTINFO_SUCCESS,
    payload,
});

export const setGroupListInfoM = (payload: I_GroupListInfoReq) => ({
    type: actionTypes.SET_GROUPLISTINFOM,
    payload,
});

export const setGroupListInfoMSUCCESS = (payload: any) => ({
    type: actionTypes.SET_GROUPLISTINFOM_SUCCESS,
    payload,
});

export const setGroupListInfoMSUCCESS_IsmoreSchedule = (payload: any) => ({
    type: actionTypes.SET_GROUPLISTINFOM_SUCCESS_ISMORESCHEDULE,
    payload,
});

export const setSingleGroupListInfo = (payload: I_SingleGroupListInfoReq) => ({
    type: actionTypes.SET_SINGLEGROUPLISTINFO,
    payload,
});

export const setSingleGroupListInfoSUCCESS = (payload: any) => ({
    type: actionTypes.SET_SINGLEGROUPLISTINFO_SUCCESS,
    payload,
});

export const setSingleGroupListInfoM = (payload: I_SingleGroupListInfoReq) => ({
    type: actionTypes.SET_SINGLEGROUPLISTINFOM,
    payload,
});

export const setSingleGroupListInfoMSUCCESS = (payload: any) => ({
    type: actionTypes.SET_SINGLEGROUPLISTINFOM_SUCCESS,
    payload,
});

export const setSingleGroupListInfoMSUCCESS_IsmoreSchedule = (payload: any) => ({
    type: actionTypes.SET_SINGLEGROUPLISTINFOM_SUCCESS_ISMORESCHEDULE,
    payload,
});

export const setFilterItems = (payload: any) => ({
    type: actionTypes.SET_FILTERITEMS,
    payload,
});

export const setTempFilterItems = (payload: any) => ({
    type: actionTypes.SET_TEMPFILTERITEMS,
    payload,
});

export const setSortType = (payload: any) => ({
    type: actionTypes.SET_SORTTYPE,
    payload,
});

export const setSwitchListBy = (payload: any) => ({
    type: actionTypes.SET_SWITCHLISTBY,
    payload,
});

export const setTagFiltersShow = (payload: any) => ({
    type: actionTypes.SET_TAGFILTERS_SHOW,
    payload,
});

export const setTempTagFiltersShow = (payload: any) => ({
    type: actionTypes.SET_TEMPTAGFILTERS_SHOW,
    payload,
});

export const setPageSizeM = (payload: any) => ({
    type: actionTypes.SET_PAGESIZEM,
    payload,
});

export const setChangeItem = (payload: any) => ({
    type: actionTypes.SET_CHANGEITEM,
    payload,
});

export const setTags = (payload: any) => ({
    type: actionTypes.SET_TAGS,
    payload,
});

export const setTrigger = (payload: any) => ({
    type: actionTypes.SET_TRIGGER,
    payload,
});

export const setCallJson = (payload: I_CallJsonReq) => ({
    type: actionTypes.SET_CALLJSON,
    payload,
});

export const setCallJsonSUCCESS = (payload: any) => ({
    type: actionTypes.SET_CALLJSON_SUCCESS,
    payload,
});

export type I_DepthinfoAction = ReturnType<typeof setDepthinfo>;
export type I_GroupListInfoAction = ReturnType<typeof setGroupListInfo>;
export type I_GroupListInfoMAction = ReturnType<typeof setGroupListInfoM>;
export type I_SingleGroupListInfoAction = ReturnType<typeof setSingleGroupListInfo>;
export type I_SingleGroupListInfoMAction = ReturnType<typeof setSingleGroupListInfoM>;
export type I_CallJsonAction = ReturnType<typeof setCallJson>;
